import { render, staticRenderFns } from "./SupplierReport.vue?vue&type=template&id=0fd96bda&scoped=true"
import script from "./SupplierReport.vue?vue&type=script&lang=js"
export * from "./SupplierReport.vue?vue&type=script&lang=js"
import style0 from "./SupplierReport.vue?vue&type=style&index=0&id=0fd96bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd96bda",
  null
  
)

export default component.exports